<template>
    <div class="index">
        <my-header></my-header>
        <div class="index-menu-container">
            <el-menu :default-active="activeIndex" class="index-menu" mode="horizontal">
                <el-submenu v-if="userTypeNum == 0" index="1">
                    <template slot="title"><i class="iconfont icon-digital"></i>数据看板<i class="col-line data-control-line"></i></template>
                    <el-menu-item index="1-1" @click="goTargetPage('inventorydynamic')">库存动态</el-menu-item>
                    <el-menu-item index="1-2" @click="goTargetPage('storemap')">汽服门店网络图</el-menu-item>
                    <el-menu-item index="1-3" @click="goTargetPage('deliverytrail')">配送轨迹</el-menu-item>
                    <el-menu-item index="1-4" @click="goTargetPage('bigdataindex')">日报看板</el-menu-item>
                    <el-menu-item index="1-5" @click="goTargetPage('profitdataindex')">利润看板</el-menu-item>
                </el-submenu>
                <el-menu-item v-if="userTypeNum != 3" index="2" @click="goTargetPage('inventorymanage')"><i class="iconfont icon-Inventory"></i>库存管理<i class="col-line kucun-line"></i></el-menu-item>
                <el-menu-item  index="3" @click="goTargetPage('ordermanage')"><i class="iconfont icon-dingdan"></i>订单管理<i class="col-line"></i></el-menu-item>
                <el-menu-item v-if="userTypeNum != 2 && userTypeNum != 3" index="4" @click="goTargetPage('datacontrol')"><i class="iconfont icon-shuju"></i>数据监控<i class="col-line"></i></el-menu-item>
                <el-menu-item index="5" @click="goTargetPage('deliverymanage')"><i class="iconfont icon-peisongguanli"></i>配送管理<i class="col-line peisong-line"></i></el-menu-item>
                <el-menu-item v-if="userTypeNum == 0" index="6" @click="goTargetPage('usermanage')"><i class="iconfont icon-users"></i>用户管理<i class="col-line"></i></el-menu-item>
                <el-menu-item v-if="userTypeNum == 0" @click="goTargetPage('ticketmanage')" index="7" ><i class="iconfont icon-dzqgl"></i>电子券管理<i class="col-line ticket-line"></i></el-menu-item>
                <el-menu-item v-if="userTypeNum == 0" @click="goTargetPage('marketingmanage')" class="last-menu-item" index="8"><i class="iconfont icon-yingxiaozhanghu"></i>营销管理</el-menu-item>
            </el-menu>
        </div>
        <div class="content-index">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
import store from '../store/index'
import {mapGetters, mapMutations} from 'vuex';
import Header from '../component/Header.vue';

export default {
    data () {
        return {
            activeIndex: '1',
        }
    },
    computed: {
        ...mapGetters(['user', 'userTypeNum'])
    },
    created() {
    },
    methods: {
        timing(page){
            let canIntervalArray = ["profitdataindex","bigdataindex", "deliverytrail", "inventorydynamic","storemap"] //数据看版的四个子模块
            clearInterval(store.state.timer); //一进来先清除定时器，无论有还是没有
            console.log("关闭计时器")
            if(canIntervalArray.indexOf(page)!=-1){  //如果跳的路由是数据看版中的路由，则启动计时器。
                store.state.timer = setInterval(() => {
                    this.newOrderCheck()
                },11000)
                console.log("启动计时器")
            }
        },
        newOrderCheck(){
            var _this = this
            var ajax = new XMLHttpRequest();
            ajax.open('get','https://xarh.sprucesmart.com/api/v3/order/new_order_remind/');
            ajax.setRequestHeader("Accept","application/json; charset=utf-8");
            ajax.send();
            ajax.onreadystatechange = function () {
                if (ajax.readyState==4 &&ajax.status==200) {
                    // console.log("ajax.responseText----",ajax.responseText);
                    let res = JSON.parse(ajax.responseText)
                    // console.log("res----",res)
                    if(res.results.new_order) {
                        _this.$notify.success({
                            title: '消息',
                            duration: 300000,
                            message: '您有新的订单'
                        })
                    }
                    // }else{
                    //     _this.$notify.error({
                    //         title: '消息',
                    //         duration: 3000,
                    //         message: '暂无新订单'
                    //     })
                    // }
                }
            }
        },
        goTargetPage (page) {
            // console.log("page--===",page)
            this.timing(page)
            if(page == 'ordermanage' && this.userTypeNum == 3) {
                this.$router.push({
                    path: '/index/ordermanage/feiyouorderlist'
                })
            }
            else {
                this.$router.push({
                    'name': page
                })
            }
        }
    },
    components: {
        'my-header': Header
    }
}
</script>
<style scoped>
@import url(https://at.alicdn.com/t/font_976438_kvydgtappuo.css);
.index-menu-container {
    width: 100%;
    margin: 0 auto;
    background-color: #fff;
    box-shadow: 1px 4px 15px #ccc;
    /* background-color: red; */
    position: relative;
    z-index: 24;
}
.index-menu {
    width: 1190px;
    margin: 0 auto;

}
.index-menu .el-menu-item {
    color: #4c4c4c;
    font-size: 16px;
    font-weight: 700;
    padding: 0 30px;
}
.index-menu .iconfont {
    position: relative;
    top: -1px;
    padding-right: 6px;
}
.index-menu .col-line {
    position: absolute;
    top: 22px;
    left: 144px;
    height: 13.5px;
    border-right: 2px solid #00ae66;
}
.index-menu .data-control-line {
    left: 120px ;
}
.index-menu .ticket-line {
    left: 160px;
}
.index-menu .peisong-line {
    left: 148px;
}
.index-menu .kucun-line {
    left: 144px;
}
.content-index {
    margin: 0 auto;
}
</style>








// WEBPACK FOOTER //
// src/pages/Index.vue